import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-responsive mx-5" }
const _hoisted_2 = {
  key: 1,
  class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Worker"),
    /*#__PURE__*/_createElementVNode("th", null, "Skill"),
    /*#__PURE__*/_createElementVNode("th", null, "Shifts"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_BookableUser = _resolveComponent("BookableUser")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isFetchingUsers && _ctx.users.length == 0)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "No users matching your criteria where found"
        }))
      : (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createBlock(_component_BookableUser, {
                onCreateApplication: _cache[0] || (_cache[0] = 
            data => {
              _ctx.$emit('create-application', data);
            }
          ),
                selectedSkill: _ctx.selectedSkill,
                key: user.id,
                user: user
              }, null, 8, ["selectedSkill", "user"]))
            }), 128))
          ])
        ])),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.pagination.currentPage,
      totalPages: _ctx.pagination.totalPages,
      onChangeCurrentPage: _cache[1] || (_cache[1] = 
        pageNumber => {
          _ctx.$emit('changePage', pageNumber);
        }
      )
    }, null, 8, ["currentPage", "totalPages"])
  ]))
}